<script setup lang="ts">
import {computed, inject, ref} from 'vue'
import type {usePrincipalStore} from '@/stores/iam/principal-store'
import {useLocalization} from '@hantera/portal-app'
import PermissionPicker from '../Shared/PermissionPicker.vue'

const store = inject<ReturnType<typeof usePrincipalStore>>('principalStore')!
const t = useLocalization('iam.principals')

const searchQuery = ref('')

// Note: Inherited permissions calculation removed since RoleListItem 
// doesn't include permissions array (lightweight list response)
const inheritedPermissions = computed(() => [])

// Use pending or actual permissions (acl in backend)
const displayPermissions = computed({
  get: () => store.pendingPermissions ?? store.principal?.acl ?? [],
  set: (value: string[]) => {
    store.pendingPermissions = value
  },
})
</script>

<template>
  <div class="toolbar">
    <input
      v-model="searchQuery"
      type="text"
      :placeholder="t('permissions.search')"
    />
  </div>

  <div class="picker-margin">
    <PermissionPicker
      v-if="store.principal"
      v-model="displayPermissions"
      v-model:search-query="searchQuery"
      :inherited-permissions="inheritedPermissions"
      :readonly="!store.canWrite"
    />
  </div>

  <div v-if="store.hasPermissionsChanges" class="action-bar">
    <button @click="store.savePermissions" class="btn-primary">{{ t('actions.saveChanges') }}</button>
    <button @click="store.discardPermissions" class="btn-silent">{{ t('actions.discard') }}</button>
  </div>
</template>

<style scoped>
.picker-margin {
  padding: 1.5rem;
  height: 100%;
}

.action-bar {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  border-top: 1px solid hsl(var(--color-80));
  background: hsl(var(--color-90));
  position: sticky;
  bottom: 0;
  box-shadow: 0 0px 20px var(--color-shadow);
}
</style>
